import React from "react";
import {
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Tooltip,
  Typography,
  withStyles,
  TextField,
  InputAdornment,
} from "@material-ui/core";


const CommonFilters = (props) =>{
    return(
        <>
        {/* First Group */}
                    <Grid container item style={{ padding: 10, paddingTop: 15 }} xs={6}>
                      <Grid
                        item
                        spacing={2}
                        xs={12}
                        container
                        component={Paper}
                        style={{ paddingTop: 8 }}
                      >
                        <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                          <FormControl fullWidth className={props.classes.formControl}>
                            <InputLabel
                              className={props.classes.filterLabel}
                              style={{
                                color: !props.state[props.variableCols.Industry].includes(
                                  "All"
                                )
                                  ? "#4472c4"
                                  : "#000",
                              }}
                              id="select-industry-label"
                            >
                              {props.company === "C0003" ? "Region:" : "Industry:"}
                            </InputLabel>
                            <Select
                              data-test="Industry"
                              value={props.state[props.variableCols.Industry]}
                              onChange={props.handleChange}
                              name={props.variableCols.Industry}
                              multiple
                            >
                              <MenuItem value={"All"}>All</MenuItem>
                              {props.funnelCompareFilters !== "" &&
                                props.funnelCompareFilters
                                  .filter(
                                    (y) =>
                                      y.type === props.variableCols.Industry &&
                                      y[props.variableCols.Industry] !== ""
                                  )
                                  .sort((a, b) =>
                                    a[props.variableCols.Industry] <
                                    b[props.variableCols.Industry]
                                      ? -1
                                      : a[props.variableCols.Industry] >
                                        b[props.variableCols.Industry]
                                      ? 1
                                      : 0
                                  )
                                  .map((y) => (
                                    <MenuItem
                                      key={y[props.variableCols.Industry]}
                                      value={y[props.variableCols.Industry]}
                                    >
                                      {y[props.variableCols.Industry]}
                                    </MenuItem>
                                  ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                          <FormControl fullWidth className={props.classes.formControl}>
                            <InputLabel
                              className={props.classes.filterLabel}
                              style={{
                                color: !props.state[
                                  props.variableCols.CustomerSegment
                                ].includes("All")
                                  ? "#4472c4"
                                  : "#000",
                              }}
                              id="select-region-label"
                            >
                              {props.company === "C0003"
                                ? "Segment:"
                                : "Customer Segment:"}
                            </InputLabel>
                            <Select
                              data-test="Customer Segment"
                              value={props.state[props.variableCols.CustomerSegment]}
                              onChange={props.handleChange}
                              name={props.variableCols.CustomerSegment}
                              multiple
                            >
                              <MenuItem value={"All"}>All</MenuItem>
                              {props.funnelCompareFilters !== "" &&
                                props.funnelCompareFilters &&
                                props.funnelCompareFilters
                                  .filter(
                                    (y) =>
                                      y.type === props.variableCols.CustomerSegment &&
                                      y[props.variableCols.CustomerSegment] !== ""
                                  )
                                  .map((y) => (
                                    <MenuItem
                                      key={y[props.variableCols.CustomerSegment]}
                                      value={y[props.variableCols.CustomerSegment]}
                                    >
                                      {y[props.variableCols.CustomerSegment]}
                                    </MenuItem>
                                  ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                          <FormControl fullWidth className={props.classes.formControl}>
                            <InputLabel
                              className={props.classes.filterLabel}
                              style={{
                                color: !props.state[
                                  props.variableCols.CustomerType
                                ].includes("All")
                                  ? "#4472c4"
                                  : "#000",
                              }}
                              id="select-industry-label"
                            >
                              {props.company === "C0003"
                                ? "Opportunity Type:"
                                : "Customer Type:"}
                            </InputLabel>
                            <Select
                              data-test="Customer Type"
                              value={props.state[props.variableCols.CustomerType]}
                              onChange={props.handleChange}
                              name={props.variableCols.CustomerType}
                              multiple
                            >
                              <MenuItem value={"All"}>All</MenuItem>
                              {props.funnelCompareFilters !== "" &&
                                props.funnelCompareFilters
                                  .filter(
                                    (y) =>
                                      y.type === props.variableCols.CustomerType &&
                                      y[props.variableCols.CustomerType] !== ""
                                  )
                                  .sort((a, b) =>
                                    a[props.variableCols.CustomerType] <
                                    b[props.variableCols.CustomerType]
                                      ? -1
                                      : a[props.variableCols.CustomerType] >
                                        b[props.variableCols.CustomerType]
                                      ? 1
                                      : 0
                                  )
                                  .map((y) => (
                                    <MenuItem
                                      key={y[props.variableCols.CustomerType]}
                                      value={y[props.variableCols.CustomerType]}
                                    >
                                      {y[props.variableCols.CustomerType]}
                                    </MenuItem>
                                  ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                    {/* Second Group */}
                    <Grid container item style={{ padding: 10, paddingTop: 15 }} xs={6}>
                      <Grid
                        item
                        spacing={2}
                        xs={12}
                        container
                        component={Paper}
                        style={{ paddingTop: 8 }}
                      >
                        <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                          {props.company === "C0024" ? (
                            <FormControl fullWidth className={props.classes.formControl}>
                              <InputLabel
                                className={props.classes.filterLabel}
                                style={{
                                  color: !props.state[
                                    props.variableCols.Lead_Source_Category__c
                                  ].includes("All")
                                    ? "#4472c4"
                                    : "#000",
                                }}
                                id="select-region-label"
                              >
                                Lead Source Category:
                              </InputLabel>
                              <Select
                                data-test="Lead_Source_Category__c"
                                value={props.state[props.variableCols.Lead_Source_Category__c]}
                                onChange={props.handleChange}
                                name={props.variableCols.Lead_Source_Category__c}
                                multiple
                              >
                                <MenuItem value={"All"}>All</MenuItem>
                                {props.funnelCompareFilters !== "" &&
                                  props.funnelCompareFilters
                                    .filter(
                                      (y) =>
                                        y.type === props.variableCols.Lead_Source_Category__c &&
                                        y[props.variableCols.Lead_Source_Category__c] !== ""
                                    ).sort((a, b) =>
                                      a[props.variableCols.Lead_Source_Category__c].localeCompare(b[props.variableCols.Lead_Source_Category__c])
                                    )
                                    .map((y) => (
                                      <MenuItem
                                        key={y[props.variableCols.Lead_Source_Category__c]}
                                        value={y[props.variableCols.Lead_Source_Category__c]}
                                      >
                                        {y[props.variableCols.Lead_Source_Category__c]}
                                      </MenuItem>
                                    ))}
                              </Select>
                            </FormControl>
                          ) : (
                          <FormControl fullWidth className={props.classes.formControl}>
                              <InputLabel
                                className={props.classes.filterLabel}
                                style={{
                                  color: !props.state[
                                    props.variableCols.Lead_Source
                                  ].includes("All")
                                    ? "#4472c4"
                                    : "#000",
                                }}
                                id="select-region-label"
                              >
                                Lead Source:
                              </InputLabel>
                              <Select
                                data-test="Lead_Source"
                                value={props.state[props.variableCols.Lead_Source]}
                                onChange={props.handleChange}
                                name={props.variableCols.Lead_Source}
                                multiple
                              >
                                <MenuItem value={"All"}>All</MenuItem>
                                {props.funnelCompareFilters !== "" &&
                                  props.funnelCompareFilters
                                    .filter(
                                      (y) =>
                                        y.type === props.variableCols.Lead_Source &&
                                        y[props.variableCols.Lead_Source] !== ""
                                    ).sort((a, b) =>
                                      a[props.variableCols.Lead_Source].localeCompare(b[props.variableCols.Lead_Source])
                                    )
                                    .map((y) => (
                                      <MenuItem
                                        key={y[props.variableCols.Lead_Source]}
                                        value={y[props.variableCols.Lead_Source]}
                                      >
                                        {y[props.variableCols.Lead_Source]}
                                      </MenuItem>
                                    ))}
                              </Select>
                            </FormControl>
                            )}
                        </Grid>
        
                        <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                          <FormControl fullWidth className={props.classes.formControl}>
                            <InputLabel
                              className={props.classes.filterLabel}
                              style={{
                                color: !props.state[
                                  props.variableCols.Opp_Created_By
                                ].includes("All")
                                  ? "#4472c4"
                                  : "#000",
                              }}
                              id="select-opp_created_by"
                            >
                              {'Opp. created by:'}
                            </InputLabel>
                            <Select
                              value={props.state[props.variableCols.Opp_Created_By]}
                              onChange={props.handleChange}
                              name={props.variableCols.Opp_Created_By}
                              data-test={props.variableCols.Opp_Created_By}
                              multiple
                            >
                              <MenuItem value={"All"}>All</MenuItem>
                              {props.funnelCompareFilters !== "" &&
                                props.funnelCompareFilters
                                  .filter(
                                    (y) =>
                                      y.type === props.variableCols.Opp_Created_By &&
                                      y[props.variableCols.Opp_Created_By] !== ""
                                  ).sort((a, b) =>
                                    a[props.variableCols.Opp_Created_By].localeCompare(b[props.variableCols.Opp_Created_By])
                                  ) 
                                  .map((y) => (
                                    <MenuItem
                                      key={y[props.variableCols.Opp_Created_By]}
                                      value={y[props.variableCols.Opp_Created_By]}
                                    >
                                      {y[props.variableCols.Opp_Created_By]}
                                    </MenuItem>
                                  ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                          {["C0020","C0024"].includes(props.company) ? (
                          <FormControl fullWidth className={props.classes.formControl}>
                            <InputLabel
                              className={props.classes.filterLabel}
                              style={{
                                color: !props.state[
                                  props.variableCols.Product_Family
                                ].includes("All")
                                  ? "#4472c4"
                                  : "#000",
                              }}
                              id="select-industry-label"
                            >
                              Product Family Contains:
                            </InputLabel>
                            <Select
                              value={props.state[props.variableCols.Product_Family]}
                              onChange={props.handleChange}
                              name={props.variableCols.Product_Family}
                              data-test={props.variableCols.Product_Family}
                              multiple
                            >
                              <MenuItem value={"All"}>All</MenuItem>
                              {props.funnelCompareFilters !== "" &&
                                props.funnelCompareFilters
                                  .filter(
                                    (y) =>
                                      y.type === props.variableCols.Product_Family &&
                                      y[props.variableCols.Product_Family] !== ""
                                  )
                                  .map((y) => (
                                    <MenuItem
                                      key={y[props.variableCols.Product_Family]}
                                      value={y[props.variableCols.Product_Family]}
                                    >
                                      {
                                        y[props.variableCols.Product_Family]
                                      }
                                    </MenuItem>
                                  ))}
                            </Select>
                          </FormControl>
                          ):(
                            <FormControl fullWidth className={props.classes.formControl}>
                            <InputLabel
                              className={props.classes.filterLabel}
                              style={{
                                color: !props.state[
                                  props.variableCols.Acct_Vertical
                                ].includes("All")
                                  ? "#4472c4"
                                  : "#000",
                              }}
                              id="select-industry-label"
                            >
                              Solution Category:
                            </InputLabel>
                            <Select
                              value={props.state[props.variableCols.Acct_Vertical]}
                              onChange={props.handleChange}
                              name={props.variableCols.Acct_Vertical}
                              data-test={props.variableCols.Acct_Vertical}
                              multiple
                            >
                              <MenuItem value={"All"}>All</MenuItem>
                              {props.funnelCompareFilters !== "" &&
                                props.funnelCompareFilters
                                  .filter(
                                    (y) =>
                                      y.type === props.variableCols.Acct_Vertical &&
                                      y[props.variableCols.Acct_Vertical] !== ""
                                  )
                                  .sort((a, b) =>
                                    a[props.variableCols.Acct_Vertical] <
                                    b[props.variableCols.Acct_Vertical]
                                      ? -1
                                      : a[props.variableCols.Acct_Vertical] >
                                        b[props.variableCols.Acct_Vertical]
                                      ? 1
                                      : 0
                                  )
                                  .map((y) => (
                                    <MenuItem
                                      key={y[props.variableCols.Acct_Vertical]}
                                      value={y[props.variableCols.Acct_Vertical]}
                                    >
                                      {
                                        y[
                                          props.company === "C0008"
                                            ? "label"
                                            : props.variableCols.Acct_Vertical
                                        ]
                                      }
                                    </MenuItem>
                                  ))}
                            </Select>
                          </FormControl>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                    </>
    )
}

export default CommonFilters;